import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import {Container} from "reactstrap"
import { connect } from "react-redux"

//i18n
import { withTranslation } from "react-i18next"
import axios from "axios"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import RsLink from "components/buttons/rsLink";
import { API_URL } from "helpers/app_url";
import UnlayerUpdateTemp from "pages/Campaign/unlayer-update-template";
class UpdateCustomTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templateName : '',
            design: {},
            id: '',           
            projectId: '',    
            templateId: ''  
        }
      
        this.exportHtml = this.exportHtml.bind(this);
        this.LoadUnlayerRef = React.createRef();   
    }
  

      componentDidMount() {
       
        const { match } = this.props;
        const {  templateId } = match.params;
        
    }
      exportHtml = () => {
        
        
        if (this.LoadUnlayerRef && this.LoadUnlayerRef.current) {
      
          this.LoadUnlayerRef.current.exportHtml((htmlContent) => {
            
            //
            const payload = {
              'agentId': parseInt(localStorage.getItem("userId")),
              'emailCampaignFullContent': JSON.stringify(htmlContent.design),
             
              'emailCampaignTitle' : this.props.emailTemplateTitle,
              'emailCampaignContent' : htmlContent.html,
              'IsActive':true
            };
              const obj = JSON.parse(localStorage.getItem("authUser"));
              const token = obj.resultData.bearerToken;
              const str = 'Bearer ' + token;
              const headers = {
                  'Content-Type': 'application/json',
                  'Authorization': str
              }
              
              toast.loading("Please wait...");
              axios.post(`${API_URL}ProjectEmailCampaign`, payload, {
                  headers: headers
                })
                .then((response) => {
                    toast.dismiss();
                  
                    //this.props.history.push('/pre-construction/mail-send/' + response.data.projectEmailCampaign.id + '/' + response.data.projectEmailCampaign.projectEmailCampaignId);
                })
                .catch((error) => {
                 
                }) 
            });
           

        }
      };
     
    
    render() {
     
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Email Editor | Realty Space</title>
                    </MetaTags>
                    <ToastContainer autoClose={2000} />
                    <Container fluid>
                        {/* Render Breadcrumb */}
                    <div>
                  
                    <span className="float-start mb20">
                        <RsLink className="btn btn-light btn-md" iconClass="bx bx-arrow-back" to={`/custom-email-template`}>
                            Back
                        </RsLink>
                    </span>
                    <span className="float-end">
           
            <button onClick={this.exportHtml}
              
              className="btn btn-primary w-md me-2"
             
            >
             Save
            </button>
            </span>
                    <UnlayerUpdateTemp  ref={this.LoadUnlayerRef} />
                    </div>
                    </Container>
                </div>
            </React.Fragment>
        )
    }



}
UpdateCustomTemplate.propTypes = {
    t: PropTypes.any,
    history:PropTypes.object,
    match:PropTypes.object,
    emailTemplateTitle:PropTypes.object,
  
}
const mapStateToProps = ({ Project }) => (
    {
     
  
    })
  const mapDispatchToProps = dispatch => ({
   
 
  });
export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(UpdateCustomTemplate))